import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '../../../../../../common/react/components/select';
import { getTranslation } from '../../../../../../common/react/utils/translations';
import { leaderboardDataSelector } from '../../../../store/js/modules/draft-tracker/leaderboard/selectors/data-selector';
import { UPDATE_NAV_ITEM } from '../../../../store/js/modules/draft-tracker/leaderboard/actions';
import { leaderboardNavSelector } from '../../../../store/js/modules/draft-tracker/leaderboard/selectors';

export const RoundNavItem = ({ year }) => {
    const dispatch = useDispatch();
    const nav = useSelector(leaderboardNavSelector);
    const draftData = useSelector((state) =>
        leaderboardDataSelector(state, year)
    );
    const roundList = [
        ...new Set(
            draftData?.draftFeeds?.[0]?.selections?.map(
                (item) => item.roundNumber
            )
        )
    ];
    const rounds = [
        { id: -1, name: getTranslation('label.draftTracker.allRounds') },
        ...roundList?.map((item) => ({ id: item, name: item }))
    ];

    return (
        <Select
            items={rounds}
            itemToString={(item) => item?.name}
            initialSelectedItem={rounds[0]}
            activeItem={rounds.find((item) => item.id === nav.round)}
            label={getTranslation('label.stats.round')}
            onSelectedItemChange={({ selectedItem }) => {
                dispatch(
                    UPDATE_NAV_ITEM.request({
                        navItem: 'round',
                        value: selectedItem.id
                    })
                );
            }}
        />
    );
};

RoundNavItem.propTypes = {
    year: PropTypes.string.isRequired
};
